<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4.66675L8 8.66675L12 4.66675" stroke="#0071FA" stroke-width="2"/>
        <path d="M11.3335 12L4.66683 12" stroke="#0071FA" stroke-width="2"/>
    </svg>
</template>
<script setup lang="ts">
</script>